import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { paymentsShape, hotelShape, customerShape, passengersShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';

import { getBookingExtrasURL } from 'utils/urls';
import { codes as paymentCodes } from 'constants/payment';
import BackLink from 'components/ui/BackLink';
import { Page, Row } from 'components/shared/Layout';
import Tabs from 'components/ui/Tabs';
import HotelCompensationCard from './HotelCompensationCard';
import HotelCompensationVoucher from './HotelCompensationVoucher';
import { CARD_TAB_VALUE, VOUCHER_TAB_VALUE, cardTab, voucherTab } from './HotelCompensation.utils';

const HotelCompensation = ({ onSubmit, reference, hotel, payments, passengers, customer, loading }) => {
  const history = useHistory();
  const location = useLocation();
  const membershipNumber = new URLSearchParams(history.location.search).get('membershipNumber');

  const tabs = [cardTab, voucherTab];

  const cardPayments = payments.filter(
    ({ method }) =>
      method === paymentCodes.CARD ||
      method === paymentCodes.APPLE_PAY ||
      method === paymentCodes.GOOGLE_PAY ||
      method === paymentCodes.IDEAL ||
      method === paymentCodes.PAYPAL
  );

  const hash = location?.hash?.substring(1) || tabs[0].value;
  const [activeTab, setActiveTab] = useState(hash);

  const renderTabs = {
    [VOUCHER_TAB_VALUE]: (
      <HotelCompensationVoucher
        reference={reference}
        hotel={hotel}
        passengers={passengers}
        customer={customer}
        loading={loading}
        onSubmit={onSubmit}
      />
    ),
    [CARD_TAB_VALUE]: (
      <HotelCompensationCard reference={reference} hotel={hotel} payments={cardPayments} loading={loading} onSubmit={onSubmit} />
    )
  };

  return (
    <Page data-testid="hotel-compensation">
      <Row span={14} start={2}>
        <BackLink to={getBookingExtrasURL(reference, membershipNumber)}>
          <FormattedMessage id="extras.title" />
        </BackLink>
        <h1>
          <FormattedMessage id="hotelCompensation.title" />
        </h1>
        <Tabs tabs={tabs} onClick={setActiveTab} selectedValue={activeTab} />
        {renderTabs[activeTab]}
      </Row>
    </Page>
  );
};

HotelCompensation.propTypes = {
  hotel: hotelShape,
  reference: PropTypes.string,
  onSubmit: PropTypes.func,
  payments: paymentsShape.isRequired,
  loading: PropTypes.bool,
  passengers: passengersShape,
  customer: customerShape
};

export default HotelCompensation;
